import { TableColumnType } from "components/UI/Table/types/table.ts";
import { ReactNode } from "react";

export interface EntityColumnOptions<T, E> extends Omit<Partial<TableColumnType<T>>, "render"> {
    title: ReactNode;
    getEntity: (record: T) => E | null | undefined;
    render?: TableColumnType<T>["render"];
}

export function entityColumn<T, E>(
    defaults: Omit<TableColumnType<T>, "title" | "render">,
    renderEntity: (entity: E | null | undefined) => ReactNode,
    options: EntityColumnOptions<T, E>
): TableColumnType<T> {
    const { getEntity, render, ...overrides } = options;

    return {
        ...defaults,
        ...overrides,
        render: render ?? ((_: unknown, record: T) => renderEntity(getEntity(record))),
    };
}
